import createCache, { type EmotionCache } from "@emotion/cache";

/**
 * `prepend: true` moves MUI/emotion styles to the top of <head> so plain CSS
 * modules and global styles can override them without `!important`.
 */
const createEmotionCache = (): EmotionCache =>
  createCache({ key: "css", prepend: true });

export default createEmotionCache;
